import axios from "axios";


/**
 * @param {Array} products - Array de productos para los cuales se generará la URL de la plantilla del proveedor.
 *
 * products = [
 *  {
 *    upc: "123456789012",
 *    category_id: 10,
 *  }
 * ]
 *
*/
export async function GetProviderTemplateURL({
  products = []
}) {

  try {

    const articles = products.map(product => ({
      upc: product.upc,
      categoryId: parseInt(product.category_id)
    }));

    const {data} = await axios.post(process.env.REACT_APP_GENERATE_PROVIDER_TEMPLATE, {
      articles
    }, {
      headers: {
        Authorization: sessionStorage.getItem("jwt"),
      },
    })
    ;

    console.log('Data of endpoint')
    console.log({data});

    return {
      url: data?.body?.url
    }

  } catch (error) {
    console.log("Error getting provider template URL:", error);
    return {
      error: error.message || "Error desconocido"
    }
  }

}

export async function SaveBulkProducts({
  products = []
}) {

  try {

    if(!Array.isArray(products) || products.length === 0) throw new Error('No hay productos por procesar');

    const {data} = await axios.post(process.env.REACT_APP_SAVE_BULK_PROVIDER_ARTICLES, {
      articles: products
    }, {
      headers: {
        Authorization: sessionStorage.getItem("jwt"),
      },
    })
    ;

    // console.log({data});

    if(data?.body?.error) throw new Error(`${data?.body?.error}: ${data?.body?.errorMessage}`);

    return {
      data: data?.body
    }

  } catch (error) {
    console.log("Error getting provider template URL:", error);
    return {
      error: error.message || "Error desconocido"
    }
  }

}
